import { Flex, useToast } from "@chakra-ui/react";
import { Post } from "api";
import React, { useCallback, useState } from "react";
import { RedeemedCoupon } from "views/admin/partnerDetail/types";
import { columnsDataComplex } from "views/admin/partnerDetail/variables/columnsData";
import ComplexTable from "./ComplexTable";

interface CouponsViewProps {
  redeemedCoupons?: RedeemedCoupon[];
  partnerId: number;
  getPartnerDetails: (partnerId: number) => void;
}

const CouponsView = (props: CouponsViewProps) => {
  const { redeemedCoupons, partnerId, getPartnerDetails } = props;

  const toast = useToast();
  const tableColumns = columnsDataComplex;

  const [loading, setLoading] = useState(false);

  const onRedeemClick = useCallback(
    async (code: string) => {
      setLoading(true);
      try {
        const redeemCouponResponse = await Post(
          `/manage/partners/${partnerId}/coupons`,
          {
            voucherCode: code,
          }
        );

        if (redeemCouponResponse.err) {
          toast({
            status: "error",
            title: "Coupon Code not Applied",
            description: redeemCouponResponse.err,
          });
        } else {
          toast({
            status: "success",
            title: "Success",
            description: "Coupon code used successfully.",
          });
          getPartnerDetails(partnerId);
        }
      } catch (error: any) {
        console.warn(error);
      } finally {
        setLoading(false);
      }
    },
    [partnerId, toast, getPartnerDetails]
  );

  return (
    <Flex flexDir={"column"} mt={8}>
      <ComplexTable
        isLoading={false}
        columnsData={tableColumns}
        tableData={redeemedCoupons ?? []}
        onRedeemClick={onRedeemClick}
        couponLoading={loading}
      />
    </Flex>
  );
};

export default CouponsView;
